import { useState } from 'react';
import { useStore } from '../../context/StoreContext';
import { X } from 'lucide-react';

export function AnnouncementBar() {
  const { settings } = useStore();
  const [dismissed, setDismissed] = useState(false);

  if (!settings.announcement_enabled || !settings.announcement_text || dismissed) {
    return null;
  }

  return (
    <div className="bg-ink text-ink-inverted text-xs tracking-wider uppercase py-2 px-4 flex items-center justify-between border-b border-ink/20">
      <div className="flex-1 text-center font-medium">
        {settings.announcement_text}
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-ink-inverted/60 hover:text-ink-inverted transition-colors p-1"
        aria-label="Dispensar aviso"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
